import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deactivateEatApp,
  getEatAppRestaurants,
  getEatAppStatus,
  saveEatAppMappings,
  syncEatApp,
  updateEatAppPullSettings,
  validateEatApp,
} from "../../api/EatAppApi";

export const useGetEatAppStatus = (organisationId, enabled = true) => useQuery({
  queryKey: ["eat-app-status", organisationId],
  queryFn: () => getEatAppStatus(organisationId),
  enabled: Boolean(organisationId) && enabled,
});

export const useGetEatAppRestaurants = (organisationId, configId, enabled = true) => useQuery({
  queryKey: ["eat-app-restaurants", organisationId, configId],
  queryFn: () => getEatAppRestaurants(organisationId, configId),
  enabled: Boolean(organisationId && configId && enabled),
});

export const useValidateEatApp = () => useMutation({ mutationFn: validateEatApp });
export const useSaveEatAppMappings = () => useMutation({ mutationFn: saveEatAppMappings });
export const useUpdateEatAppPullSettings = () => useMutation({ mutationFn: updateEatAppPullSettings });
export const useDeactivateEatApp = () => useMutation({ mutationFn: deactivateEatApp });
export const useSyncEatApp = () => useMutation({ mutationFn: syncEatApp });
